import { ADMIN_NAVIGATOR, STAFF_NAVIGATOR, INPUTER_NAVIGATOR } from "@/constants/navigators"
import { ROLES } from "@/constants/options";

export const renderNavigator = (role: any) => {
  switch (role) {
    case ROLES.ADMIN:
      return ADMIN_NAVIGATOR;
    case ROLES.STAFF:
      return STAFF_NAVIGATOR;
    case ROLES.INPUTER:
      return INPUTER_NAVIGATOR;
    default:
      return [];
  }
};
